// Why a position was closed, as the backend stamped it

export const CLOSE_REASON = {
  MANUAL: "manual",
  PARTIAL: "partial",
  TAKE_PROFIT: "take_profit",
  STOP_LOSS: "stop_loss",
  LIQUIDATION: "liquidation",
};

/**
 * @param {object} position position of our API
 * @returns {string|null} CLOSE_REASON value, null while the position is open
 *   and for trades closed before the backend started to save the reason
 */
export const getCloseReason = (position) => position?.close_reason ?? null;
